export default function LeadershipSection() {
  const leaders = [
    {
      name: "Dr. Sarah Mitchell",
      title: "President & CEO",
      specialty: "PharmD, MBA",
      bio: "With over 20 years in pharmacy practice and healthcare administration, Dr. Mitchell leads CPVA's vision for integrated healthcare.",
      image: "Professional headshot of female pharmacy leader in business attire, confident smile, medical background, professional healthcare executive portrait with clean white background"
    },
    {
      name: "Dr. Michael Chen",
      title: "Chief Veterinary Officer",
      specialty: "DVM, PhD",
      bio: "A renowned veterinarian and researcher, Dr. Chen oversees veterinary programs and cross-disciplinary initiatives.",
      image: "Professional headshot of male veterinarian in white coat, friendly demeanor, clinical background, experienced veterinary professional portrait with clean medical setting"
    },
    {
      name: "Jennifer Rodriguez",
      title: "Director of Operations",
      specialty: "MSc, PMP",
      bio: "Jennifer brings extensive experience in healthcare operations and project management to drive organizational excellence.",
      image: "Professional headshot of female healthcare administrator, business professional attire, modern office background, confident healthcare operations leader portrait"
    },
    {
      name: "Dr. James Thompson",
      title: "Chair, Board of Directors",
      specialty: "PharmD, FCSHP",
      bio: "A respected pharmacy leader and educator, Dr. Thompson guides CPVA's strategic direction and governance.",
      image: "Professional headshot of male pharmacy board chair, distinguished appearance, academic background, senior healthcare leadership portrait with professional setting"
    },
    {
      name: "Dr. Lisa Wang",
      title: "Director of Education",
      specialty: "DVM, MEd",
      bio: "Dr. Wang develops innovative educational programs that bridge pharmacy and veterinary disciplines.",
      image: "Professional headshot of female veterinary educator, warm smile, educational background, experienced veterinary education leader portrait with academic setting"
    },
    {
      name: "Robert Kumar",
      title: "Director of Advocacy",
      specialty: "JD, MPA",
      bio: "Robert leads CPVA's advocacy efforts, working with government and stakeholders to advance healthcare policy.",
      image: "Professional headshot of male healthcare policy advocate, business suit, government building background, experienced policy professional portrait with formal setting"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Leadership Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the dedicated professionals who guide CPVA's mission and drive innovation in healthcare collaboration.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {leaders.map((leader, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-64">
                <img
                  src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg$%7Bleader.image%7D&width=400&height=300&seq=leader${index}&orientation=portrait`}
                  alt={leader.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{leader.name}</h3>
                <h4 className="text-blue-600 font-semibold mb-2">{leader.title}</h4>
                <p className="text-sm text-gray-500 mb-3">{leader.specialty}</p>
                <p className="text-gray-600 text-sm leading-relaxed">{leader.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}